export interface VolumeCalculatorRecord {
    departureAirport: string;
    arrivalAirport: string;
    scheduledDepartureDateFrom: string;
    scheduledDepartureDateTo: string;
    numberOfFlights: number;
    fuelSupplier: string;
    avg3M: number;
    acTypesDict: number;
}
